exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-footer-actions .v-icon{cursor:pointer;font-size:28px!important;margin-left:8px;margin-right:8px\n}", ""]);

// exports
